import { Box, Spinner } from '@chakra-ui/react'

export const WorkflowLoadingSpinner = (): JSX.Element => (
  <Box alignItems='center' display='flex' justifyContent='center' py='32px'>
    <Spinner size='md' />
  </Box>
)
